export function renderMarketsColumnsFilter(markets, columns) {
    let marketsTrimmed = markets;
    Object.keys(columns).forEach((key) => {
        columns[key] && (marketsTrimmed = markets.slice(0, parseInt(key)));
    });
    return marketsTrimmed;
}
//# sourceMappingURL=renderMarketsColumnsFilter.js.map